module.exports = __webpack_public_path__ + "img/35.d34b341c.jpg";